import React from 'react';
import { Route } from 'react-router-dom';
import PrivateContentRenderer from './PrivateContentRenderer';
import { connect } from 'react-redux';
import { isJigsawOnly } from '../../api/redux-watson/watson-config-selectors';
import { FILE_NOT_FOUND } from '../../api/redux-route/routes';

class RouteRendererInternal extends React.Component {
  render() {
    const {
      hasAccess,
      redirectTo,
      bridgeRequired,
      jigsawOnly,
      ...innerProps
    } = this.props;

    const blocked = jigsawOnly && bridgeRequired;

    return (
      <PrivateContentRenderer
        component={Route}
        hasAccess={hasAccess && !blocked}
        redirectTo={blocked ? FILE_NOT_FOUND : redirectTo}
        innerProps={innerProps}
      />
    );
  }
}

const mapStateToProps = state => ({
  jigsawOnly: isJigsawOnly(state),
});

export default connect(mapStateToProps)(RouteRendererInternal);
